<template lang="">
    <el-form ref="form" :model="form" :rules="rules"  :inline="true"
    label-width="70px"
    class="login_container">
        <h3 class="login_title">{{$t('login.title')}}</h3>
        <el-form-item label="用户名" prop="username" >
            <el-input v-model="form.username" placeholder="请输入用户名"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password" >
            <el-input v-model="form.password" type="password" placeholder="请输入密码"></el-input>
        </el-form-item>
        <el-button type="primary" @click="login">{{$t('login.btn')}}</el-button>
    </el-form>
</template>
<script>
import Mock from 'mockjs'
import Cookie from 'js-cookie'
import { getMenu } from '../api'
export default {
    data() {
        return {
            form: {
                username: '',
                password: '',
            },
            rules: {
                username: [
                    { required: true, trigger: 'blur', message: '请输入用户名' }
                ],
                password: [
                    { required: true, trigger: 'blur', message: '请输入密码' }
                ],
            }
        }
    },
    methods: {
        //登录
        login() {
            // //生成一段随机字符串，代替token
            // const token = Mock.Random.guid()
            // //token信息存入cookie 用于不同页面间的通信
            // Cookie.set('token', token)
            //校验通过
            this.$refs.form.validate((valid) => {
                if (valid) {
                    getMenu(this.form).then(({ data }) => {
                        console.log(data)
                        if (data.code === 20000) {
                            // Cookie.set('token', data.data.token)
                            localStorage.setItem('token', data.data.token)
                            this.$message({
                                message: '登录成功',
                                type: 'success'
                            });

                            //根据登录账号修改对应的菜单列表
                            this.$store.commit('GET_MENU', data.data.menu)
                            //修改路由
                            this.$store.commit('GET_SUBROUTER', this.$router)
                            //跳转到首页
                            this.$router.push('/')
                        } else {
                            this.$message.error(data.data.message)
                        }
                    })
                }
            })


        }
    },
}
</script>
<style lang="less" scoped>
.login_container {

    width: 350px;
    margin: 180px auto;
    padding: 35px 35px 15px;

    border-radius: 15px;
    border: 1px solid #eaeaea;
    box-shadow: 0 0 25px #cac6c6;

    display: flex;
    flex-direction: column;
    align-items: center;

    .login_title {
        margin-bottom: 10px;
        color: #505458;
    }

    .el-input {
        width: 198px;
    }

    .el-button {
        margin-top: 5px;
    }
}
</style>